module.exports = __webpack_public_path__ + "static/img/hezuo04.afb2c00.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/images/imgsrc/hezuo04.jpg
// module id = Lzyv
// module chunks = 1